import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { avatarImage } from './avatarArt';
import logoUrl from '../assets/images/cleveroo-logo.png';
import './AccountPages.css';

/**
 * Student account profile page (route: /profile).
 * Read-only summary of the signed-in account. Name editing lives in Settings.
 */
const Profile: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const name = user?.name || 'Student';
  const initial = name.trim()[0]?.toUpperCase() || 'S';
  const email = user?.email || '—';
  const role = user?.role || 'student';
  const provider = user?.provider === 'google' ? 'Google' : 'Email & password';

  return (
    <div className="cvr-account">
      <div className="cvr-account__bar">
        <button type="button" className="cvr-account__back" onClick={() => navigate('/')}>
          ← Dashboard
        </button>
        <span className="cvr-account__brand">
          <img src={logoUrl} alt="" />
          Cleveroo
        </span>
      </div>

      <div className="cvr-account__wrap">
        <h1 className="cvr-account__title">Profile</h1>

        <div className="cvr-card">
          <div className="cvr-profile__head">
            <span className="cvr-profile__avatar">
              {avatarImage(user?.avatar)
                ? <img className="cvr-avatar-img" src={avatarImage(user?.avatar)!} alt="" />
                : initial}
            </span>
            <div>
              <div className="cvr-profile__name">{name}</div>
              <div className="cvr-profile__email">{email}</div>
              <div className="cvr-profile__badges">
                <span className="cvr-badge">{role}</span>
                {user?.provider === 'google' && <span className="cvr-badge">Google account</span>}
              </div>
            </div>
          </div>
        </div>

        <div className="cvr-card">
          <h2 className="cvr-card__h">Account details</h2>
          <div className="cvr-field">
            <span className="cvr-field__label">Name</span>
            <span className="cvr-field__value">{name}</span>
          </div>
          <div className="cvr-field">
            <span className="cvr-field__label">Email</span>
            <span className="cvr-field__value">{email}</span>
          </div>
          <div className="cvr-field">
            <span className="cvr-field__label">Role</span>
            <span className="cvr-field__value" style={{ textTransform: 'capitalize' }}>{role}</span>
          </div>
          <div className="cvr-field">
            <span className="cvr-field__label">Sign-in method</span>
            <span className="cvr-field__value">{provider}</span>
          </div>
        </div>

        <button type="button" className="cvr-btn cvr-btn--ghost" onClick={() => navigate('/settings')}>
          Edit in Settings
        </button>
      </div>
    </div>
  );
};

export default Profile;
